module.exports = __webpack_public_path__ + "src/assets/img/data.bab13d5c.jpg";